module.exports = __webpack_public_path__ + "img/loader-new.c27009d.gif";